// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firebase-database";

const firebaseConfig = {
  apiKey: "AIzaSyA_3wZ5C8ryrO816KooP15E17mR66mqzu8",
  authDomain: "herndonmap.firebaseapp.com",
  databaseURL: "https://herndonmap-default-rtdb.firebaseio.com",
  projectId: "herndonmap",
  storageBucket: "herndonmap.firebasestorage.app",
  messagingSenderId: "226242219882",
  appId: "1:226242219882:web:e4b01d8a4cb2c7bae3df13",
  measurementId: "G-CPMPK6TZPM"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
